import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { alpha, Box, ButtonBase, IconButton, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useObservable } from '@ocodelib/mui/hooks';
import type { ProjectFile } from '@repo/project-interface';
import { useState } from 'react';
import { useP5BasicApp } from '../../useP5BasicApp';

export function WorkspaceFileList() {
  const { app } = useP5BasicApp();
  const fileList = useObservable(app.files$) ?? [];
  const selectedFile = useObservable(app.selectedFile$);

  const handleClickFile = (file: ProjectFile) => () => {
    if (!app) return;
    app.setSelectedFile(file);
  };

  // 이름 변경 또는 삭제
  const handleClickFileAction = (file: ProjectFile) => (action: 'rename' | 'delete') => {
    console.log('handleClickFileAction');
    if (!app) return;
    // app.setSelectedFile(file);
    alert(file.name + ' : ' + action);
  };

  return (
    <Box
      className="WorkspaceFileList-root"
      sx={{
        width: 200,
        display: 'flex',
        flexDirection: 'column',
        borderRight: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        background: (theme) =>
          `linear-gradient(to bottom, ${alpha(theme.palette.primary.main, 0.0)}, ${alpha(theme.palette.primary.main, 0.05)})`,
      }}
    >
      <Box
        sx={{
          height: 40,
          // bgcolor: '#edeff1',
          display: 'flex',
          alignItems: 'center',
          px: 1,
        }}
      >
        <Typography variant="body2">Files</Typography>
      </Box>
      <Box
        component="ul"
        sx={{
          flex: 1,
          listStyle: 'none',
          // bgcolor: '#edeff1',
          color: '#181818',
          p: 0,
          m: 0,
          '& > li': {
            '& .FileItemBox-root': {
              pl: 1,
            },
            ...(selectedFile && {
              [`&[data-model-id="${selectedFile?.fileKey}"]`]: {
                color: 'primary.main',
                bgcolor: 'rgba(255, 255, 255, 0.2)',
              },
            }),
          },
        }}
      >
        {fileList.map((file) => (
          <li key={file.fileKey} data-model-id={file.fileKey}>
            <FileItemBox
              file={file}
              selected={selectedFile?.fileKey === file.fileKey}
              onClick={handleClickFile(file)}
              onClickAction={handleClickFileAction(file)}
            />
          </li>
        ))}
      </Box>
    </Box>
  );
}

function FileItemBox(props: {
  file: ProjectFile;
  selected?: boolean;
  onClick?: React.MouseEventHandler;
  onClickAction?: (action: 'rename' | 'delete') => void;
}) {
  const { file, selected = false, onClick, onClickAction } = props;
  const [actionAnchorEl, setActionAnchorEl] = useState<null | HTMLElement>(null);
  const actionMenuOpened = Boolean(actionAnchorEl);

  const handleOpenActionMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    setActionAnchorEl(e.currentTarget);
  };

  const handleCloseActionMenu = () => {
    setActionAnchorEl(null);
  };

  const handleClickAction = (action: 'rename' | 'delete') => (e: React.MouseEvent) => {
    setActionAnchorEl(null);
    setTimeout(() => {
      onClickAction?.(action);
    }, 100);
  };

  return (
    <ButtonBase
      className="FileItemBox-root"
      component="div"
      disableRipple
      sx={{
        width: '100%',
        height: 40,
        justifyContent: 'flex-start',
      }}
      onClick={onClick}
    >
      <Typography
        component="span"
        sx={{
          flex: 1,
          textAlign: 'left',
        }}
        variant="body2"
      >
        {file.name}
      </Typography>

      {selected && (
        <IconButton
          size="small"
          color="primary"
          sx={{
            color: 'primary.main',
          }}
          onClick={handleOpenActionMenu}
        >
          <ArrowDropDownIcon />
        </IconButton>
      )}
      <Menu anchorEl={actionAnchorEl} open={actionMenuOpened} onClose={handleCloseActionMenu}>
        <MenuItem onClick={handleClickAction('rename')}>이름 변경</MenuItem>
        <MenuItem onClick={handleClickAction('delete')}>삭제</MenuItem>
      </Menu>
    </ButtonBase>
  );
}
